// Sistema de deshacer/rehacer del TURNO mediante instantáneas.
// Guarda copias serializadas del estado de tablero + atril del jugador activo.
import { deepClone } from '../utils/helpers.js';

export class MoveManager {
  constructor() {
    this.initial = null; // estado al inicio del turno
    this.undoStack = [];
    this.redoStack = [];
  }

  /** Marca el estado inicial del turno. */
  begin(snapshot) {
    this.initial = deepClone(snapshot);
    this.undoStack = [];
    this.redoStack = [];
  }

  /** Guarda el estado ACTUAL antes de aplicar un movimiento (para poder deshacerlo). */
  record(currentSnapshot) {
    this.undoStack.push(deepClone(currentSnapshot));
    this.redoStack = []; // cualquier movimiento nuevo invalida el rehacer
  }

  canUndo() {
    return this.undoStack.length > 0;
  }
  canRedo() {
    return this.redoStack.length > 0;
  }

  /** Deshace el último movimiento. Devuelve el snapshot a restaurar o null. */
  undo(currentSnapshot) {
    if (!this.undoStack.length) return null;
    this.redoStack.push(deepClone(currentSnapshot));
    return this.undoStack.pop();
  }

  /** Rehace. Devuelve el snapshot a restaurar o null. */
  redo(currentSnapshot) {
    if (!this.redoStack.length) return null;
    this.undoStack.push(deepClone(currentSnapshot));
    return this.redoStack.pop();
  }

  /** Reinicia el turno al estado inicial. Devuelve el snapshot inicial. */
  reset() {
    this.undoStack = [];
    this.redoStack = [];
    return deepClone(this.initial);
  }
}
